import React from 'react';
import cx from 'classnames';
import Box, { HORIZONTAL } from '../../../layout/box';
import Text from '../../../text';
import { dataPathToObjBreadcrumbs } from '../util';
import { ZoomOut } from '../../../icons';
import { makeStyles } from '../../../../theme';
import { callWith } from '../../../../../util';

const breadCrumbStyles = makeStyles(
    ({ palette, spacing }) => ({
        txt: {
            marginRight: spacing(0.5),
            fontSize: '0.85rem',
            color: palette.grey[700]
        },
        clickable: {
            cursor: 'pointer',
            '&:hover': {
				textDecoration:'underline',
                color: palette.secondary.contrastText
            }
        }
    })
);

const ObjBreadcrumbs = React.memo(
    ({ dataPath, gotoBreadcrumb }) => {
        const classes = breadCrumbStyles();
        const breadCrumbs = dataPathToObjBreadcrumbs(dataPath);

        return breadCrumbs && breadCrumbs.map((b, i) => {
            const txt = i === 0 ? b.text : `[${b.text}]`;
            const onClick = b.url && callWith(gotoBreadcrumb, b.url);
            return <Text className={cx(classes.txt, b.url && classes.clickable)} key={i} {...onClick && { onClick }}>{txt}</Text>
        });
    }
);

const styles = makeStyles(
    () => ({
        zoomOutIcon: {
            cursor: 'pointer'
        }
    })
);

const ObjZoomOut = React.memo(
    ({ dataPath, onObjZoomOut}) => {
        const classes = styles();

        return (
            <Box type={HORIZONTAL}>
				<ZoomOut onClick={callWith(onObjZoomOut, '')} className={classes.zoomOutIcon} />
                <ObjBreadcrumbs dataPath={dataPath} gotoBreadcrumb={onObjZoomOut} />
            </Box>
        );
    }
);

export default ObjZoomOut;